export default __webpack_public_path__ + "static/media/element_spec_57.9f77c0f1.webp";